import { api } from '../axios'
import type { ApiResponse, Medium } from '../../../types'

export const mediumsApi = {
  getAll: () =>
    api.get<ApiResponse<Medium[]>>('/mediums'),

  getAllIncludingInactive: () =>
    api.get<ApiResponse<Medium[]>>('/mediums/all'),

  getActive: () =>
    api.get<ApiResponse<Medium[]>>('/mediums/active'),

  getById: (id: number) =>
    api.get<ApiResponse<Medium>>(`/mediums/${id}`),

  create: (data: Medium) =>
    api.post<ApiResponse<Medium>>('/mediums', data),

  update: (id: number, data: Partial<Medium>) =>
    api.put<ApiResponse<Medium>>(`/mediums/${id}`, data),

  delete: (id: number) =>
    api.delete<ApiResponse>(`/mediums/${id}`),

  hardDelete: (id: number) =>
    api.delete<ApiResponse>(`/mediums/${id}/permanent`),
}

